import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  BaseForm,
  BaseButton,
  BaseTextContent,
  XrkMessage,
  BaseDialog,
  BaseFormItem,
  BaseInput,
  BaseSelect
} from 'xrk-components';
import { TERMINATE } from '../../constants';
import { AuditParams } from '../../data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'terminate-dialog',
  props: {
    remove: {},
    auditAjax: {},
    id: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const formRef = ref();
const formData = ref<AuditParams>({
  id: +props.id,
  status: 4,
  auditTerminationReason: '',
  auditTerminationRemark: ''
});

const onConfirm = async () => {
  await formRef.value.validate();
  await props.auditAjax(formData.value);
  XrkMessage.success('操作成功');
  emits('success');
  props.remove();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "550px",
    title: "终止原因",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    "show-footer": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        click: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref_key: "formRef",
            ref: formRef,
            "label-position": "right",
            model: formData.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "原因类别",
                prop: "auditTerminationReason",
                rules: [
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseSelect), {
                    placeholder: "请选择",
                    options: _unref(TERMINATE),
                    modelValue: formData.value.auditTerminationReason,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.auditTerminationReason) = $event))
                  }, null, 8, ["options", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "备注",
                prop: "auditTerminationRemark",
                rules: [
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    type: "text",
                    placeholder: "请输入",
                    modelValue: formData.value.auditTerminationRemark,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.auditTerminationRemark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})